/* eslint-disable */
// @ts-nocheck
import * as R from 'ramda';
import { reducerWrapper } from '../support/utils';
import { IS_EVENT_INGESTION_HEALTHY, DUPLICATE_DATA_SOURCES } from '../actions/HealthCheckActions';
const INIT_STATE = {
  isEventIngestionHealthy: null,
  duplicateDataSources: [],
};

function Handler(state = INIT_STATE, action) {
  switch (action.type) {
    case IS_EVENT_INGESTION_HEALTHY.response:
      return R.merge(state, {
        isEventIngestionHealthy: action.data,
      });

    case DUPLICATE_DATA_SOURCES.response:
      return R.merge(state, {
        duplicateDataSources: action.data,
      });

    default:
      return state;
  }
}

const HealthCheckReducer = reducerWrapper(INIT_STATE, Handler, {
  resetOn: ['APP_CHANGE'],
});
export default HealthCheckReducer;
